module.exports = __webpack_public_path__ + "static/img/logo09.36052ebd.png";